import React, {useState} from 'react';
import GetAppIcon from '@material-ui/icons/GetApp';
import {compose} from 'redux';
import {connect} from 'react-redux';
import withStyles from '@material-ui/core/styles/withStyles';
import {Button, showNotification} from 'react-admin';
import axiosInstance from "../../api/axios";
import {CircularProgress} from "@material-ui/core";
import {showErrorNotify, showSuccessNotify} from "../../components";

const styles = {
    button: {
        margin: 1,
        width: 180
    },
};

const EduDataSync = (props) => {
    const [isLoading, setIsLoading] = useState(false)
    const handleClick = (e) => {
        e.stopPropagation();
        setIsLoading(true)
        axiosInstance.post('/api/eduDatas/syncFromEdu').then(res => {
            showSuccessNotify('Đồng bộ thành công')
            setTimeout(() => {
                window.location.reload()
            }, 1000)
            setIsLoading(false)
        }, err => {
            showErrorNotify(err.message)
            setIsLoading(false)
        })
    };

    return (
        <React.Fragment>
            {isLoading && <CircularProgress style={{marginRight: 10}} color="secondary"/>}
            <Button color="primary" style={styles.button} disabled={isLoading}
                    onClick={handleClick} label={'Đồng bộ từ EDU'}>
                <GetAppIcon/>
            </Button>
        </React.Fragment>
    )
};

export default compose(
    connect(null, {showNotification}),
    withStyles(styles)
)(EduDataSync)
